<div class="picklist-wrapper" *ngIf="!isMobile">
    <p-pickList #productsPickList [source]="source()" [target]="target" [responsive]="true"
        class="z-2 s-s-l-picklistProducts" [dragdrop]="true" filterBy="name"
        sourceFilterPlaceholder="Buscar por nome" (onMoveToSource)="onMoveToSource($event)"
        (onMoveToTarget)="onMoveToTarget($event)">

        <!-- FILTRO CUSTOMIZADO NO SOURCE (busca remota, substitui o padrão da PickList) -->
        <ng-template pTemplate="sourceFilter">
            <div class="p-picklist-filter-container p-0 border-none">
                <input type="text" pInputText class="p-picklist-filter w-full" placeholder="Buscar por nome"
                    [(ngModel)]="remoteFilter" (ngModelChange)="onSourceFilterChange($event)" />
            </div>
        </ng-template>

        <ng-template pTemplate="sourceHeader">
            <div class="flex align-items-center justify-content-between w-full">
                <span>Disponíveis ({{ sourceProductsCount() }})</span>
            </div>
        </ng-template>

        <ng-template pTemplate="targetHeader">
            <div class="flex align-items-center justify-content-between w-full">
                <span>Selecionados ({{ target.length }})</span>
                <ng-container *ngTemplateOutlet="targetHeaderTemplate ?? null"></ng-container>
            </div>
        </ng-template>

        <ng-template let-product pTemplate="item" let-i="index">
            <ng-container *ngIf="!product.__loading; else loadingItem">
                <ng-container
                    *ngTemplateOutlet="itemTemplate ?? null; context: { $implicit: product, index: i }"></ng-container>
            </ng-container>

            <ng-template #loadingItem>
                <div class="flex flex-column p-2 gap-2 w-full pointer-events-none">
                    <div class="flex align-items-center gap-2">
                        <p-skeleton width="4rem" height="4rem" styleClass="border-round"></p-skeleton>
                        <div class="flex flex-column flex-1 gap-1">
                            <p-skeleton width="70%" height="1rem"></p-skeleton>
                            <p-skeleton width="40%" height="0.8rem"></p-skeleton>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-template>
    </p-pickList>
</div>

<div class="picklist-wrapper" *ngIf="isMobile">
    <p-pickList #productsPickList [source]="source()" [target]="target" [responsive]="true"
        class="z-2 mt-2 mb-2 s-s-l-picklistProducts" [dragdrop]="isDragDrop" filterBy="name"
        sourceFilterPlaceholder="Buscar por nome" (onMoveToSource)="onMoveToSource($event)"
        (onMoveToTarget)="onMoveToTarget($event)">

        <ng-template pTemplate="sourceHeader">
            <div>
                Disponíveis ({{ sourceProductsCount() }})
                <i *ngIf="isDragDrop" class="pi pi-arrows-alt p-2"></i>
            </div>
        </ng-template>

        <ng-template pTemplate="targetHeader">
            <div class="flex align-items-center justify-content-between w-full">
                <span>Selecionados ({{ target.length }})</span>
                <ng-container *ngTemplateOutlet="targetHeaderTemplate ?? null"></ng-container>
            </div>
        </ng-template>

        <ng-template let-product pTemplate="item" let-i="index">
            <ng-container *ngIf="!product.__loading; else loadingItemMobile">
                <ng-container
                    *ngTemplateOutlet="itemTemplate ?? null; context: { $implicit: product, index: i }"></ng-container>
            </ng-container>

            <ng-template #loadingItemMobile>
                <div class="flex flex-column p-2 gap-2 w-full pointer-events-none">
                    <div class="flex align-items-center gap-2">
                        <p-skeleton width="4rem" height="4rem" styleClass="border-round"></p-skeleton>
                        <div class="flex flex-column flex-1 gap-1">
                            <p-skeleton width="70%" height="1rem"></p-skeleton>
                            <p-skeleton width="40%" height="0.8rem"></p-skeleton>
                        </div>
                    </div>
                </div>
            </ng-template>
        </ng-template>
    </p-pickList>
</div>
